module.exports = __webpack_public_path__ + "static/img/content-img-2.00ef7d97.jpg";